/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */
import React from "react";
import { TimelineDivider } from "./timeline-divider";
import { RichTextImage } from "cms/shared/images/rich-text-image";

const TimelineItem = (props) => {
    const { item } = props;
    const { image, milestone, timeframe } = item || {};
    const { image: image_guid } = image || {};


    return (
        <div className='timeline-item'>
            <TimelineDivider />
            <div className='timeline-item-content'>
                {milestone && <h6>{milestone}</h6>}
                {timeframe && <h3>{timeframe}</h3>}
                {/* {image_guid && <SimpliCityFormattedImage image={image_guid} />} */}
                {image_guid &&
                    <div className='timeline-image-wrapper'>
                        <RichTextImage image={image_guid} />
                    </div>
                }
            </div>
        </div>
    );
};

TimelineItem.displayName = "TimelineItem";
export { TimelineItem };
